import React, { useState, useEffect } from "react";
import { useImpactReadOnly, openImpactBoxIfReadOnly } from "app/routes/psp/management/useImpactReadOnly";
import { useSelector } from "react-redux";
import IntlMessages, { IntlGetText } from "util/IntlMessages";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import SylvantForm from "./Form";
import Table from "./Table";
import { callApiAsync, postCreateUpdateSylvant, postDeleteSylvant } from "api/apiList";
import { BoolList, DiagnosticCodeCIEList } from "constants/Enums";
import { NotificationManager } from "react-notifications";
import DeleteSylvant from "./Delete";

const SylvantDialog = ({ open, handleRequestClose, loadSylvant, sylvantInfo }) => {
  const readOnlyImpactView = useImpactReadOnly();
  const { selectedPrescription } = useSelector(({ management }) => management);
  const [openCRU, setOpenCRU] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [currentRowObj, setCurrentRowObj] = useState(null);
  const msgSuccess = IntlGetText("core.SuccessSave");

  useEffect(() => {
    if (open) loadSylvant();
  }, [open]);

  // useEffect(() => {
  //   if (open) {
  //     console.log("📌 Ejecutando loadSylvant()");
  //     loadSylvant();
  //   }
  // }, [open]);


  const handleCreateUpdate = async (data) => {
    await callApiAsync(
      () => postCreateUpdateSylvant(data),
      () => {
        setOpenCRU(false);
        NotificationManager.success(msgSuccess);
        loadSylvant();
      }
    );
  };

  const handleDelete = async () => {
    await callApiAsync(
      () => postDeleteSylvant(currentRowObj.id),
      () => {
        setOpenDeleteDialog(false);
        NotificationManager.success(msgSuccess);
        loadSylvant();
      }
    );
  };

  return (
    <Dialog
      fullWidth
      maxWidth="md"
      open={open}
      disableBackdropClick
      onClose={handleRequestClose}
    >
      <DialogTitle>
        <IntlMessages id="core.vital.not.available" />
      </DialogTitle>
      <DialogContent>
        <Table
          data={Array.isArray(sylvantInfo) ? sylvantInfo : sylvantInfo ? [sylvantInfo] : []}
          handleOpenCRU={() => setOpenCRU(true)}
          handleOpenDel={() => setOpenDeleteDialog(true)}
          setCurrentRowObj={setCurrentRowObj}
          sylvantInfo={sylvantInfo}
          showAddButton
          readOnly={readOnlyImpactView}
          DiagnosticCodeCIEList={DiagnosticCodeCIEList()}
        />
        <SylvantForm
          rowObj={currentRowObj}
          prescriptionId={selectedPrescription?.id}
          openCRU={openCRU}
          handleRequestClose={() => setOpenCRU(false)}
          handleCreateUpdate={handleCreateUpdate}
          sylvantInfo={Array.isArray(sylvantInfo) ? sylvantInfo : sylvantInfo ? [sylvantInfo] : []}
          readOnly={readOnlyImpactView}
          DiagnosticCodeCIEList={DiagnosticCodeCIEList()}
          boolList={BoolList()}
        />
        <DeleteSylvant
          open={openDeleteDialog}
          handleRequestClose={() => setOpenDeleteDialog(false)}
          handleDelete={handleDelete}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={handleRequestClose} color="secondary">
          <IntlMessages id="core.close" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SylvantDialog;
